<div class="wrapper wrapper-content">
  <div class="row">
    <div class="col-lg-3">
      <div class="ibox float-e-margins">
        <div class="ibox-title">
          <span class="label label-primary pull-right" style="font-size:13px;">Última</span>
          <h5>Salarios</h5>
        </div>
        <div class="ibox-content">
          <h1 class="no-margins">{{totalSalario | number:'1.2-2'}}</h1>
          <!-- <div class="stat-percent font-bold text-success">98% <i class="fa fa-bolt"></i></div> -->
          <small>Total Salarios</small>
        </div>
      </div>
    </div>
    <div class="col-lg-3">
      <div class="ibox float-e-margins">
        <div class="ibox-title">
          <span class="label label-warning pull-right" style="font-size:13px;">Mensual</span>
          <h5>Ausentismos</h5>
        </div>
        <div class="ibox-content">
          <h1 class="no-margins">{{totalAusentismosM | number:'1.2-2'}}</h1>
          <!-- <div class="stat-percent font-bold text-navy">44% <i class="fa fa-level-up"></i></div> -->
          <small>Total Ausentismos</small>
        </div>
      </div>
    </div>
    <div class="col-lg-3">
      <div class="ibox float-e-margins">
        <div class="ibox-title">
          <span class="label label-info pull-right" style="font-size:13px;">Anual</span>
          <h5>Ausentismos</h5>
        </div>
        <div class="ibox-content">
          <h1 class="no-margins">{{totalAusentismosA | number:'1.2-2'}}</h1>
          <!-- <div class="stat-percent font-bold text-info">20% <i class="fa fa-level-up"></i></div> -->
          <small>Total Ausentismos</small>
        </div>
      </div>
    </div>
    <div class="col-lg-3">
      <div class="ibox float-e-margins">
        <div class="ibox-title">
          <span class="label label-success pull-right" style="font-size:13px;">Total</span>
          <h5>Empleados</h5>
        </div>
        <div class="ibox-content">
          <h1 class="no-margins">{{totalEmpleados | number:'1.0-0'}}</h1>
          <!-- <div class="stat-percent font-bold text-navy">38% <i class="fa fa-level-down"></i></div> -->
          <small>Total Vigentes</small>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-12">
      <div class="ibox float-e-margins">
        <div class="ibox-title">
          <h5>Salarios</h5>
          <div class="float-right">
            <div class="btn-group">
              <button *ngIf="tipoCuadro == 1" type="button" class="btn btn-xs btn-white active" (click)="cuadroAnioActual()">Año {{anioActual}}</button>
              <button *ngIf="tipoCuadro != 1" type="button" class="btn btn-xs btn-white" (click)="cuadroAnioActual()">Año {{anioActual}}</button>
              <button *ngIf="tipoCuadro == 2" type="button" class="btn btn-xs btn-white active" (click)="cuadroAnioAnterior()">Año {{anioActual - 1}}</button>
              <button *ngIf="tipoCuadro != 2" type="button" class="btn btn-xs btn-white" (click)="cuadroAnioAnterior()">Año {{anioActual - 1}}</button>
              <button *ngIf="tipoCuadro == 3" type="button" class="btn btn-xs btn-white active" (click)="cuadroCincoAnios()">{{anioActual - 4}} - {{anioActual}}</button>
              <button *ngIf="tipoCuadro != 3" type="button" class="btn btn-xs btn-white" (click)="cuadroCincoAnios()">{{anioActual - 4}} - {{anioActual}}</button>
            </div>
          </div>          
        </div>
        <div class="ibox-content">
          <div class="row">
            <div class="col-lg-9">
              <div class="flot-chart">
                <div *ngIf="tipoCuadro != 3" flotChart class="flot-chart-content" [options]="flotOptions" [dataset]="flotDataset"></div>
                <div *ngIf="tipoCuadro == 3" flotChart class="flot-chart-content" [options]="flotOptions2" [dataset]="flotDataset"></div>
              </div>
            </div>
            <div class="col-lg-3">
              <ul class="stat-list">
                <li>
                  <h2 class="no-margins">{{sumSalario | number:'1.0-0'}}</h2>
                  <small>Total salarios del período</small>
                  <!-- <div class="stat-percent">48% <i class="fa fa-level-up text-navy"></i></div> -->
                  <div class="progress progress-mini">
                    <div style="width: 100%;" class="progress-bar"></div>
                  </div>
                </li>
                <li>
                  <h2 class="no-margins ">{{sumEmpleados | number:'1.0-0'}}</h2>
                  <small>Total empleados del período</small>
                  <!-- <div class="stat-percent">60% <i class="fa fa-level-down text-navy"></i></div> -->
                  <div class="progress progress-mini">
                    <div style="width: 100%;" class="progress-bar"></div>
                  </div>
                </li>
                <li>
                  <h2 class="no-margins ">{{promedioMensual | number:'1.0-0'}}</h2>
                  <small>Promedio mensual de salarios</small>
                  <!-- <div class="stat-percent">22% <i class="fa fa-bolt text-navy"></i></div> -->
                  <div class="progress progress-mini">
                    <div style="width: 100%;" class="progress-bar"></div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>


  <div class="row">
    <div class="col-lg-6">
      <div class="ibox float-e-margins">
        <div class="ibox-title">
          <h5>Ingresos</h5>
          <!-- <iboxtools></iboxtools> -->
        </div>
        <div class="ibox-content ibox-heading">
          <small><i class="fa fa-tim"></i> Tiene {{totalAltas}} nuevos ingresos en los últimos 30 días.</small>
        </div>
        <div class="ibox-content">
          <table class="table table-hover no-margins">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Sociedad</th>
                <th>Puesto</th>
                <th>Ingreso</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor='let altas of altasList'>
                <td>{{altas.personalNavigation.apellido}}, {{altas.personalNavigation.nombre}}</td>
                <td>{{altas.sociedadNavigation.descripcion}}</td>
                <td>{{altas.posicionNavigation.descripcion}}</td>
                <td>{{altas.desde|date:'dd/MM/yyyy'}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="col-lg-6">
      <div class="ibox float-e-margins">
        <div class="ibox-title">
          <h5>Cumpleaños</h5>
          <!-- <iboxtools></iboxtools> -->
        </div>
        <div class="ibox-content">
          <table class="table table-hover no-margins">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Años</th>
                <th>Fecha Cumpleaños</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor='let cumples of cumpleaniosList'>
                <td>{{cumples.apellido}}, {{cumples.nombre}}</td>
                <td>{{cumples.titulo}}</td>
                <td>{{cumples.celular|date:'EEEE, d MMMM'}}</td>
                <td *ngIf="cumples.interno == 'S'"><i class="fa fa-birthday-cake"></i></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- <div class="col-lg-6">
      <div class="ibox float-e-margins">
        <div class="ibox-title">
          <h5>Small todo list</h5>
          <iboxtools></iboxtools>
        </div>
        <div class="ibox-content">
          <ul class="todo-list m-t small-list">
            <li *ngFor="let todo of todos; let i=index">
              <a (click)="todo.completed = !todo.completed" class="check-link"><i class="fa" [ngClass]="{'fa-check-square': todo.completed,'fa-square-o': !todo.completed}"></i> </a>
              <span class="m-l-xs" [ngClass]="{'todo-completed': todo.completed}">{{ todo.name }}</span>
              <small *ngIf="todo.time" class="label label-primary"><i class="fa fa-clock-o"></i> {{todo.time}} mins</small>
            </li>
          </ul>
        </div>
      </div>
    </div> -->



    <!-- <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Transactions worldwide</h5>
            <iboxtools></iboxtools>
          </div>
          <div class="ibox-content">

            <div class="row">
              <div class="col-lg-6">
                <table class="table table-hover margin bottom">
                  <thead>
                  <tr>
                    <th style="width: 1%" class="text-center">No.</th>
                    <th>Transaction</th>
                    <th class="text-center">Date</th>
                    <th class="text-center">Amount</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td class="text-center">1</td>
                    <td> Security doors
                    </td>
                    <td class="text-center small">16 Jun 2014</td>
                    <td class="text-center"><span class="label label-primary">$483.00</span></td>

                  </tr>
                  <tr>
                    <td class="text-center">2</td>
                    <td> Wardrobes
                    </td>
                    <td class="text-center small">10 Jun 2014</td>
                    <td class="text-center"><span class="label label-primary">$327.00</span></td>

                  </tr>
                  <tr>
                    <td class="text-center">3</td>
                    <td> Set of tools
                    </td>
                    <td class="text-center small">12 Jun 2014</td>
                    <td class="text-center"><span class="label label-warning">$125.00</span></td>

                  </tr>
                  <tr>
                    <td class="text-center">4</td>
                    <td> Panoramic pictures</td>
                    <td class="text-center small">22 Jun 2013</td>
                    <td class="text-center"><span class="label label-primary">$344.00</span></td>
                  </tr>
                  <tr>
                    <td class="text-center">5</td>
                    <td>Phones</td>
                    <td class="text-center small">24 Jun 2013</td>
                    <td class="text-center"><span class="label label-primary">$235.00</span></td>
                  </tr>
                  <tr>
                    <td class="text-center">6</td>
                    <td>Monitors</td>
                    <td class="text-center small">26 Jun 2013</td>
                    <td class="text-center"><span class="label label-primary">$100.00</span></td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="col-lg-6">
                <div jvectormap id="world-map" style="height: 300px;" [options]="mapOptions"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->


  </div>
</div>
